import boatHandmade from '../../assets/boat-handmade.png'
import boatDrag from '../../assets/boat-drag.png'
import boatSiege from '../../assets/boat-siege.png'
import boatTourist from '../../assets/boat-tourist.png'
import close from '../../assets/close.png'

const BoatCard = (props) => {
    const dropdowns = props.dropdowns

    // Check the usage type and show matching image
    const loadUsageTypeImage = () => {
        if(props.item.usageTypeId === 1) {
            return boatHandmade
        } else if (props.item.usageTypeId === 2) {
            return boatDrag
        } else if (props.item.usageTypeId === 3) {
            return boatSiege
        } else {
            return boatTourist
        }
    }

    // Check the usage type and show matching text
    const showUsageTypeText = () => {
        if(dropdowns) {
            const usageType = dropdowns.usageTypes.find((usageType) => usageType.id === props.item.usageTypeId)
            return usageType && usageType.name
        } else {
            return ''
        }
    }

    return (
        <div className='p-4 rounded-lg bg-anti-flash-white cursor-pointer' onClick={props.onPressCard}>
            <div className='flex flex-row justify-between'>

                <div className='flex flex-row items-center'>

                    <img className='h-[3.938rem] w-[3.938rem]' src={loadUsageTypeImage()} alt='Tipo de Utilização'/>

                    <div className='ms-4'>
                        <p className='font-montserrat font-semibold'>{props.item.registration}</p>
                        <p className='font-montserrat font-bold text-xl mt-1'>{props.item.name}</p>
                        <p className='font-montserrat mt-1'>{showUsageTypeText()}</p>
                    </div>

                </div>

                <button onClick={props.onPressRemove} className='self-start'>
                    <img className='h-3 w-3 ' src={close} alt='Remover Embarcação'/>
                </button>

            </div>
        </div>
    )
}

export default BoatCard